"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTMLControlRun = exports.HTMLControlRunCSS = void 0;
const react_1 = __importDefault(require("react"));
const html_1 = require("../common/html");
const sentenceChildrenRun_1 = require("../../renderer/rules/sentenceChildrenRun");
const util_1 = require("../../util");
const common_1 = require("../common");
exports.HTMLControlRunCSS = `

.control-parentheses
{
    transition: background-color 0.3s;
}

.control-parentheses:hover,
.paragraph-item-Paragraph:hover .control-parentheses
{
    background-color: hsla(60, 100%, 50%, 0.1);
}

.control-parentheses[data-parentheses_depth="1"]:hover,
.paragraph-item-Paragraph:hover .control-parentheses[data-parentheses_depth="1"]
{
    background-color: hsla(60, 100%, 50%, 0.1);
}

.control-parentheses[data-parentheses_depth="2"]:hover,
.paragraph-item-Paragraph:hover .control-parentheses[data-parentheses_depth="2"]
{
    background-color: hsla(30, 100%, 50%, 0.1);
}

.control-parentheses[data-parentheses_depth="3"]:hover,
.paragraph-item-Paragraph:hover .control-parentheses[data-parentheses_depth="3"]
{
    background-color: hsla(0, 100%, 50%, 0.1);
}

.control-parentheses[data-parentheses_depth="4"]:hover,
.paragraph-item-Paragraph:hover .control-parentheses[data-parentheses_depth="4"]
{
    background-color: hsl(330, 100%, 50%, 0.1);
}

.control-parentheses[data-parentheses_depth="5"]:hover,
.paragraph-item-Paragraph:hover .control-parentheses[data-parentheses_depth="5"]
{
    background-color: hsl(300, 100%, 50%, 0.1);
}

.control-parentheses[data-parentheses_depth="6"]:hover,
.paragraph-item-Paragraph:hover .control-parentheses[data-parentheses_depth="6"]
{
    background-color: hsl(270, 100%, 50%, 0.1);
}

.control-start-parenthesis,
.control-end-parenthesis
{
    border: 1px solid transparent;
    margin: -1px;
    transition: border-color 0.3s;
}

.control-parentheses:hover
    > .control-start-parenthesis,
.control-parentheses:hover
    > .control-end-parenthesis
{
    border-color: gray;
}

.control-mismatch-start-parenthesis {
    color: red;
}

.control-mismatch-end-parenthesis {
    color: red;
}
`;
// const isControlRunProps = (props: HTMLComponentProps): props is ControlRunProps => props.el.isControl;
exports.HTMLControlRun = (0, html_1.wrapHTMLComponent)("HTMLControlRun", ((props) => {
    const { el, htmlOptions } = props;
    if (el.tag === "__Parentheses") {
        return react_1.default.createElement(__Parentheses, { el: el, htmlOptions });
    }
    else if (el.tag === "__PStart") {
        return react_1.default.createElement(__PStart, { el: el, htmlOptions });
    }
    else if (el.tag === "__PContent") {
        return react_1.default.createElement(__PContent, { el: el, htmlOptions });
    }
    else if (el.tag === "__PEnd") {
        return react_1.default.createElement(__PEnd, { el: el, htmlOptions });
    }
    else if (el.tag === "__MismatchStartParenthesis") {
        return react_1.default.createElement(__MismatchStartParenthesis, { el: el, htmlOptions });
    }
    else if (el.tag === "__MismatchEndParenthesis") {
        return react_1.default.createElement(__MismatchEndParenthesis, { el: el, htmlOptions });
    }
    else {
        return react_1.default.createElement(sentenceChildrenRun_1.HTMLSentenceChildrenRun, { els: el.children, htmlOptions });
    }
}));
const __Parentheses = (props) => {
    const { el, htmlOptions } = props;
    const blocks = [];
    for (const child of el.children) {
        if (typeof child === "string" || child instanceof String) {
            throw new util_1.NotImplementedError("string");
        }
        else if (child.tag === "__PStart") {
            blocks.push(react_1.default.createElement(__PStart, { el: child, htmlOptions }));
        }
        else if (child.tag === "__PContent") {
            blocks.push(react_1.default.createElement(__PContent, { el: child, htmlOptions }));
        }
        else if (child.tag === "__PEnd") {
            blocks.push(react_1.default.createElement(__PEnd, { el: child, htmlOptions }));
        }
        else {
            throw new util_1.NotImplementedError(child.tag);
        }
    }
    return (react_1.default.createElement("span", { className: "control-parentheses", "data-parentheses_type": el.attr.type, "data-parentheses_depth": el.attr.depth }, (0, common_1.withKey)(blocks)));
};
const __PStart = (props) => {
    const { el, htmlOptions } = props;
    return (react_1.default.createElement("span", { className: "control-start-parenthesis", "data-parentheses_type": el.attr.type, ...(0, html_1.elProps)(el, htmlOptions) },
        react_1.default.createElement(sentenceChildrenRun_1.HTMLSentenceChildrenRun, { els: el.children, htmlOptions })));
};
const __PContent = (props) => {
    const { el, htmlOptions } = props;
    return (react_1.default.createElement("span", { className: "control-parentheses-content", "data-parentheses_type": el.attr.type, ...(0, html_1.elProps)(el, htmlOptions) },
        react_1.default.createElement(sentenceChildrenRun_1.HTMLSentenceChildrenRun, { els: el.children, htmlOptions })));
};
const __PEnd = (props) => {
    const { el, htmlOptions } = props;
    return (react_1.default.createElement("span", { className: "control-end-parenthesis", "data-parentheses_type": el.attr.type, ...(0, html_1.elProps)(el, htmlOptions) },
        react_1.default.createElement(sentenceChildrenRun_1.HTMLSentenceChildrenRun, { els: el.children, htmlOptions })));
};
const __MismatchStartParenthesis = (props) => {
    const { el, htmlOptions } = props;
    return (react_1.default.createElement("span", { className: "control-mismatch-end-parenthesis", "data-parentheses_type": el.attr.type, ...(0, html_1.elProps)(el, htmlOptions) },
        react_1.default.createElement(sentenceChildrenRun_1.HTMLSentenceChildrenRun, { els: el.children, htmlOptions })));
};
const __MismatchEndParenthesis = (props) => {
    const { el, htmlOptions } = props;
    return (react_1.default.createElement("span", { className: "control-mismatch-end-parenthesis", "data-parentheses_type": el.attr.type, ...(0, html_1.elProps)(el, htmlOptions) },
        react_1.default.createElement(sentenceChildrenRun_1.HTMLSentenceChildrenRun, { els: el.children, htmlOptions })));
};
//# sourceMappingURL=controlRun.js.map